/**
 * @file nav-items.ts
 *
 * Single source of truth for the Online Shop admin sections. Both the desktop
 * side navigation and the mobile section switcher render from this list, and
 * the router builds its routes from the same paths.
 */

import type { MessageDescriptor } from 'react-intl';
import { adminMessages } from './i18n/messages';

export type ShopTab =
  | 'products'
  | 'categories'
  | 'orders'
  | 'coupons'
  | 'shipping'
  | 'payments'
  | 'settings';

export interface ShopNavItem {
  id: ShopTab;
  path: string;
  label: MessageDescriptor;
}

export const SHOP_NAV_ITEMS: ShopNavItem[] = [
  { id: 'products', path: '/products', label: adminMessages.navProducts },
  { id: 'categories', path: '/categories', label: adminMessages.navCategories },
  { id: 'orders', path: '/orders', label: adminMessages.navOrders },
  { id: 'coupons', path: '/coupons', label: adminMessages.navCoupons },
  { id: 'shipping', path: '/shipping', label: adminMessages.navShipping },
  { id: 'payments', path: '/payments', label: adminMessages.navPayments },
  { id: 'settings', path: '/settings', label: adminMessages.navSettings },
];

export const DEFAULT_SHOP_PATH = '/products';
